import type { Query } from '@tanstack/react-query'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

import { marketApiQueryKeys } from './queryKeys'

const STORAGE_KEY = 'dontpanic.marketQuery.v1'

/** Catálogos semi-estáticos: identidad de pools/tokens/pares (métricas se refrescan en background). */
export function shouldPersistMarketQuery(query: Query): boolean {
  const key = query.queryKey
  if (!Array.isArray(key) || key[0] !== marketApiQueryKeys.all[0]) return false
  const scope = key[1]
  return scope === 'poolsMetrics' || scope === 'tokenCatalog' || scope === 'pairCatalog'
}

export function createMarketQueryPersister() {
  return createSyncStoragePersister({
    storage: window.localStorage,
    key: STORAGE_KEY,
  })
}

/** Invalida caché persistida tras un día (alineado con gcTime de catálogos). */
export const MARKET_QUERY_PERSIST_MAX_AGE_MS = 24 * 60 * 60_000
